import React from 'react';
import PropTypes from 'prop-types';

const PaymentLatest = ({ styles, invoiceObj, payInvoInfo, handlePaymentClick, showEcsInvoice }) => {
  return (
    <>
      <div className={`${styles.Accordion__Helpful} ${styles.Payfaq}`}>
        <div className="font12 fw400 color777">Latest Payment</div>
        <div className="font12 fw400 color777">{invoiceObj?.entryDate || '--'}</div>
      </div>
      {invoiceObj?.campaignName && (
        <div className={`${styles.Accordion__GreenChip} font11 fw500 mt-10`}>Active Campaigns</div>
      )}
      <div className="font14 fw500 color111 mt-6">{invoiceObj?.campaignName}</div>
      <div className="font14 fw600 color111 mt-4">₹ {invoiceObj?.instrumentAmt || '--'}</div>

      <div className={`${styles.Accordion__Contant__Btnbox}`}>
        <button
          type="button"
          className={`${styles.Accordion__Contant__Button} blue_whitefill_animate font14 fw600 color007 mt-20`}
          onClick={() => {
            payInvoInfo('invoice');
          }}
        >
          Invoice
        </button>
        {showEcsInvoice && (
          <button
            type="button"
            className={`${styles.Accordion__Contant__Button} blue_whitefill_animate font14 fw600 color007 mt-20`}
            onClick={() => {
              payInvoInfo('ecsinvoice');
            }}
          >
            ECS Invoice
          </button>
        )}
      </div>

      <div className="font12 fw600 color111 mt-15">
        <a
          className="anchor color007"
          role="button"
          type="button"
          tabIndex={0}
          onClick={handlePaymentClick}
          onKeyDown={() => {}}
          id="paymentInvoice"
        >
          Click here
        </a>{' '}
        to view and download all invoices to your device
      </div>
    </>
  );
};

export default PaymentLatest;
PaymentLatest.propTypes = {
  styles: PropTypes.object,
  invoiceObj: PropTypes.object,
  payInvoInfo: PropTypes.func,
  handlePaymentClick: PropTypes.func,
  showEcsInvoice: PropTypes.bool,
};
